import { render, staticRenderFns } from "./AppCarousel.vue?vue&type=template&id=af593654&scoped=true"
import script from "./AppCarousel.vue?vue&type=script&lang=js"
export * from "./AppCarousel.vue?vue&type=script&lang=js"
import style0 from "./AppCarousel.vue?vue&type=style&index=0&id=af593654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af593654",
  null
  
)

export default component.exports